/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('header-component');
    if (!header) return;

    // Override the dynamic width calc with a fixed breakpoint
    header.checkWidth = function () {
      if (window.innerWidth < window.theme.sizes.large) {
        this.classList.add('js__show__mobile');
      } else {
        this.classList.remove('js__show__mobile');
      }
    };

    // Re-run immediately and on resize
    header.checkWidth();
    document.addEventListener('theme:resize', () => header.checkWidth());
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
